// extracted by mini-css-extract-plugin
export var form = "_hp-0";